import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import * as reducers from 'insured-ui-state-mgmt/dist/ducks';
import { apiService, createLogger } from 'insured-ui-state-mgmt/dist/middleware';

export default function configureStore(initialState) {
  const rootReducer = combineReducers(reducers);

  let logging = false;

  if (process.env.NODE_ENV !== 'production') {
    logging = true;
  }

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(apiService, thunk, createLogger(logging)))
  );
}
